import { ArrowUpRight } from "lucide-react";

export default function AppCard({ app, large = false, testid }) {
  return (
    <a
      href={app.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`group relative flex flex-col justify-between overflow-hidden rounded-lg border border-[#102036]/10 bg-white shadow-[0_8px_30px_rgb(12,24,42,0.05)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgb(12,24,42,0.10)] ${
        large ? "min-h-[240px] p-8 sm:p-10" : "p-7"
      }`}
      aria-label={`Open ${app.name} (opens in a new tab)`}
    >
      <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#102036]/[0.05] transition-transform duration-500 group-hover:scale-150" />
      <div className="relative">
        <div className="flex items-center justify-between">
          <span className="inline-flex items-center rounded-full border border-[#3682AE]/30 bg-[#3682AE]/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#3682AE]">
            Secure portal
          </span>
          <span className="text-[11px] font-semibold tracking-wide text-[#4A5568]/70">{app.host}</span>
        </div>
        <h3 className={`mt-5 font-display font-semibold text-[#102036] ${large ? "text-3xl sm:text-4xl" : "text-2xl"}`}>
          {app.name}
        </h3>
        <p className={`mt-2 text-[#4A5568] ${large ? "max-w-md text-base" : "text-sm"}`}>{app.description}</p>
      </div>
      <div className="relative mt-8 flex items-center justify-between">
        <span className="inline-flex items-center gap-2 rounded-full bg-[#102036] px-6 py-3 text-[12px] font-bold uppercase tracking-[0.14em] text-[#FFFFFF] transition-all duration-300 group-hover:bg-[#102036]">
          Open {app.name}
        </span>
        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#102036]/15 transition-all duration-300 group-hover:border-[#102036] group-hover:bg-[#102036] group-hover:text-white">
          <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
      <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-[#3682AE] transition-all duration-500 group-hover:w-full" />
    </a>
  );
}
